import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

import { UserAvailabilityType } from '../../../../../application/user/model/user-availability.type';
import { CoachSettingsCalendarSlot } from './coach-settings-calendar.model';

export interface CoachSettingsCalendarState {
	availabilities: CoachSettingsCalendarSlot[];
	availabilityType: UserAvailabilityType;
	isSaving: boolean;
}

@Injectable()
export class CoachSettingsCalendarStore extends Store<CoachSettingsCalendarState> {
	constructor() {
		super(
			{ availabilities: [], availabilityType: UserAvailabilityType.OWN },
			{ name: `ui-coach-settings-calendar-${guid()}` }
		);
	}
}
